import { useQuery } from '@tanstack/react-query';
import type { UndefinedInitialDataOptions } from '@tanstack/react-query/src/queryOptions';

import { getCouponQRById } from '~/api/microsites/coupon';
import { qrCodeKeys } from '~/constants/queryKeys';

export default function useCouponQrData({
  couponId,
  enabled,
}: { couponId: string | number } & Partial<UndefinedInitialDataOptions>) {
  return useQuery({
    queryFn: () => getCouponQRById(couponId),
    queryKey: qrCodeKeys.couponQRDataById(couponId),
    enabled: !!couponId && !!enabled,
    select: (response) => response.data,
  });
}
